angular.module('HoldingsService', [])
.service('Holdings', [ 'Dashboard', '$http', function(Dashboard, $http){

	this.selectedAccount = null;

	return {}	
}]);